export default __webpack_public_path__ + "static/media/searchTokensButtonMobileLight.20f1be11.svg";